<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';

  import { Link } from '@shared/ui/link';

  import { walletSidebarActivity } from '../model';

  const wallet = useWallet();
</script>

<section class="text-default-600 dark:text-dark-700 dark:border-t-default-50/10 border-t p-6 text-base">
  {#if $wallet}
    <span class="font-semibold">Need help?</span> View more
    <Link
      props="{{
        class: 'underline dark:text-dark-800',
        href: 'faq/',
      }}"
      on:click="{walletSidebarActivity.close}"
    >
      FAQs.
    </Link>
    or
    <Link
      props="{{
        class: 'underline dark:text-dark-800',
        href: 'contact-us/',
      }}"
      on:click="{walletSidebarActivity.close}"
    >
      Contact us
    </Link>
  {:else}
    <p class="dark:text-default-50 font-bold">The wallet is not connecting?</p>

    Make sure your wallet supports the Ethereum network, and that your wallet browser extension is set to "On All
    Sites", or click the wallet extension icon.
    <Link
      props="{{
        class: 'underline block dark:text-dark-800',
        href: 'faq/',
      }}"
      on:click="{() => walletSidebarActivity.close()}"
    >
      Read more FAQs.
    </Link>
  {/if}
</section>
